import { render } from "./AGBView.vue?vue&type=template&id=7c51a6d1&scoped=true"
import script from "./AGBView.vue?vue&type=script&lang=js"
export * from "./AGBView.vue?vue&type=script&lang=js"

import "./AGBView.vue?vue&type=style&index=0&id=7c51a6d1&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c51a6d1"]])

export default __exports__